import { call, put, all, takeEvery } from 'redux-saga/effects'

import {
  GET_DV360_CHANNELS,
  GET_DV360_EXCHANGE_TARGETING_OPTIONS,
  GET_DV360_NEGATIVE_KEYWORD_LISTS,
  GET_DV360_TARGETING,
  GET_DV360_TARGETING_OPTIONS,
  GET_DV360_VIEWABILITY_TARGETING_OPTIONS,
  getDv360ChannelsFailure,
  getDv360ChannelsSuccess,
  getDv360ExchangeTargetingOptionsFailure,
  getDv360ExchangeTargetingOptionsSuccess,
  getDv360NegativeKeywordListsFailure,
  getDv360NegativeKeywordListsSuccess,
  getDv360TargetingFailure,
  getDv360TargetingOptionsFailure,
  getDv360TargetingOptionsSuccess,
  getDv360TargetingSuccess,
  getDv360ViewabilityTargetingOptionsFailure,
  getDv360ViewabilityTargetingOptionsSuccess,
  SEARCH_DV360_TARGETING_OPTIONS,
  searchDv360TargetingOptionsFailure,
  searchDv360TargetingOptionsSuccess,
  UPDATE_DV360_BULK_TARGETING,
  updateDv360BulkTargetingFailure,
  updateDv360BulkTargetingSuccess
} from '../actions/dv360Constants'
import {
  getDv360ChannelsService,
  getDv360NegativeKeywordListsService,
  getDv360TargetingOptionsService,
  getDv360TargetingService,
  searchTargetingOptionsService,
  updateDv360BulkTargetingService
} from '../services/dv360Constants'

function* dv360ConstantsWatcher() {
  yield all([
    // PLOP_APPEND_PATTERN_ANCHOR_WATCHER
    takeEvery(GET_DV360_TARGETING, getDv360TargetingWorker),
    takeEvery(SEARCH_DV360_TARGETING_OPTIONS, searchDv360TargetingOptionsWorker),
    takeEvery(UPDATE_DV360_BULK_TARGETING, updateDv360BulkTargetingWorker),
    takeEvery(GET_DV360_TARGETING_OPTIONS, getDv360TargetingOptionsWorker),
    takeEvery(GET_DV360_EXCHANGE_TARGETING_OPTIONS, getDv360ExchangeTargetingOptionsWorker),
    takeEvery(GET_DV360_VIEWABILITY_TARGETING_OPTIONS, getDv360ViewabilityTargetingOptionsWorker),
    takeEvery(GET_DV360_CHANNELS, getDv360ChannelsWorker),
    takeEvery(GET_DV360_NEGATIVE_KEYWORD_LISTS, getDv360NegativeKeywordListsWorker)
  ])
}

// PLOP_APPEND_PATTERN_ANCHOR_WORKER

function* getDv360TargetingWorker({ params }) {
  try {
    const response = yield call(getDv360TargetingService, params)
    yield put(getDv360TargetingSuccess(response))
  } catch (error) {
    yield put(getDv360TargetingFailure(error))
  }
}

function* searchDv360TargetingOptionsWorker({ params }) {
  try {
    const response = yield call(searchTargetingOptionsService, params)
    yield put(searchDv360TargetingOptionsSuccess(response))
  } catch (error) {
    yield put(searchDv360TargetingOptionsFailure(error))
  }
}

function* updateDv360BulkTargetingWorker({ targetingData, shouldReFetchLineItemTargeting }) {
  try {
    const response = yield call(updateDv360BulkTargetingService, targetingData)

    if (shouldReFetchLineItemTargeting) {
      // When we update targeting in edit form, we need re-fetch the targeting data
      const updatedTargetingResponse = yield call(getDv360TargetingService, {
        account: targetingData.account,
        line_item_id: targetingData.line_item_id
      })
      yield put(getDv360TargetingSuccess(updatedTargetingResponse))
    }

    yield put(updateDv360BulkTargetingSuccess(response))
  } catch (error) {
    yield put(updateDv360BulkTargetingFailure(error))
  }
}

function* getDv360TargetingOptionsWorker({ params }) {
  try {
    const response = yield call(getDv360TargetingOptionsService, params)
    yield put(getDv360TargetingOptionsSuccess(response))
  } catch (error) {
    yield put(getDv360TargetingOptionsFailure(error))
  }
}

function* getDv360ExchangeTargetingOptionsWorker({ params }) {
  try {
    const response = yield call(getDv360TargetingOptionsService, params)
    yield put(getDv360ExchangeTargetingOptionsSuccess(response))
  } catch (error) {
    yield put(getDv360ExchangeTargetingOptionsFailure(error))
  }
}

function* getDv360ViewabilityTargetingOptionsWorker({ params }) {
  try {
    const response = yield call(getDv360TargetingOptionsService, params)
    yield put(getDv360ViewabilityTargetingOptionsSuccess(response))
  } catch (error) {
    yield put(getDv360ViewabilityTargetingOptionsFailure(error))
  }
}

function* getDv360ChannelsWorker({ params }) {
  try {
    const response = yield call(getDv360ChannelsService, params)
    yield put(getDv360ChannelsSuccess(response))
  } catch (error) {
    yield put(getDv360ChannelsFailure(error))
  }
}

function* getDv360NegativeKeywordListsWorker({ params }) {
  try {
    const response = yield call(getDv360NegativeKeywordListsService, params)
    yield put(getDv360NegativeKeywordListsSuccess(response))
  } catch (error) {
    yield put(getDv360NegativeKeywordListsFailure(error))
  }
}

export default dv360ConstantsWatcher
